import { render, staticRenderFns } from "./LeagueToggle.vue?vue&type=template&id=900344de&scoped=true&"
import script from "./LeagueToggle.vue?vue&type=script&lang=js&"
export * from "./LeagueToggle.vue?vue&type=script&lang=js&"
import style0 from "./LeagueToggle.vue?vue&type=style&index=0&id=900344de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900344de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
